import React from 'react'
import { cn } from 'utils'

const SectionContent = ({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div className={cn('flex flex-wrap gap-5 justify-center', className)}>
      {children}
    </div>
  )
}

export default SectionContent
